import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services';


@Injectable({ providedIn: 'root' })
export class AuthGuardAdmin implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentDate = new Date();
        const currentUser = this.authenticationService.getCurrentJwt();
        const currentTokenExpiration = new Date(this.authenticationService.getCurrentTokenExpiration());
        const roleUser = this.authenticationService.getRole();

        if (currentUser && roleUser.includes('ROLE_ADMIN') && currentTokenExpiration > currentDate) {
            return true;
        }

        localStorage.clear();
        this.router.navigate(['xavi-pay/admin/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }



}